import styled from 'styled-components';

export const Container = styled.section`
  align-items: center;
  display: flex;
  font-family: 'DM Sans', sans-serif;
  font-size: 36px;
  font-weight: 700;
`;
Container.displayName = 'Container';

export const CupLeft = styled.svg`
  left: -16px;
  position: relative;
`;
CupLeft.displayName = 'CupLeft';

export const CupRight = styled.svg`
  z-index: 1;
`;
CupRight.displayName = 'CupRight';

export const Logo = styled.img`
  margin: 0 4px;
`;
Logo.displayName = 'Logo';

export const PointsContainer = styled.div`
  align-items: center;
  background: #ea3545;
  color: #ffffff;
  display: flex;
  height: 46px;
  margin-left: -16px;
  min-width: calc(102px - 4px);
  padding: 0 4px;
`;
PointsContainer.displayName = 'PointsContainer';

export const PointsItem = styled.span`
  min-width: 26px;
  text-align: center;
`;
PointsItem.displayName = 'PointsItem';

export const TeamName = styled.div`
  align-items: center;
  background: #232335;
  color: #ffffff;
  display: flex;
  height: 46px;
  min-width: 110px;
`;
TeamName.displayName = 'TeamName';

export const TeamNameAway = styled(TeamName)`
  justify-content: center;
  margin-left: -16px;
  padding-left: 16px;
`;
TeamNameAway.displayName = 'TeamNameAway';

export const Timer = styled.div`
  align-items: center;
  background: #ebebeb;
  border-radius: 0 0 15px 0;
  color: #000000;
  display: flex;
  height: 46px;
  justify-content: center;
  min-width: 128px;
  margin-left: -12px;
  padding-left: 12px;
  z-index: -1;
`;
Timer.displayName = 'Timer';
